import { uid } from 'quasar';
import { queryBot, queryBot2 } from 'boot/axios';

export default class {
    constructor () {
        this.key = uid();
        this.id = uid();
        this.label = 'Узел дерева';
        this.type = '';
        this.level = 0;
        this.hover = false;
        // this.icon = '';
        this.iconColor = '';
        this.img = '';
        this.avatar = '';
        this.p_children = [];
        this.disabled = false;
        this.expandable = true;
        this.selectable = true;
        this.handler = null;
        this.tickable = false;
        this.noTick = false;
        this.tickStrategy = 'none';
        this.lazy = false;
        this.header = '';
        this.body = '';
        this.parentId = '';
        this.parent = null;
        this.position = 1;
        this.visible = true;
        this.editing = false;
        this.editable = true;
        this.expanded = false;
        this.compareFunc = null;
    }

    get hasChildren () {
        return this.children.length > 0;
    }

    get children () {
        return this.p_children;
    }

    set children (value) {
        this.p_children = value;
    }

    firstChild (from = this.children) {
        return _.first(from);
    }

    lastChild (from = this.children) {
        return _.last(from);
    }

    addNode (node, to = this.children) {
        if (!_.find(to, (i) => i.id === node.id)) {
            node.parent = this;
            to.push(node);
            if (_.isFunction(this.compareFunc)) {
                to.sort(this.compareFunc);
            }
        }
    }

    moveAfter (node) {
        if (node) {
            const ind = _.findIndex(node.parent.children, (c) => c.key === node.key);
            if (ind) {
                this.parent.removeNode(this.id);
                this.parent = node.parent;
                node.parent.children.splice(ind, 0, this);
                _.each(node.parent.children, (c, i) => {
                    c.position = i;
                });
                if (_.isFunction(this.compareFunc)) {
                    node.parent.children.sort(this.compareFunc);
                }
            }
        }
    }

    removeNode (id, from = this.children) {
        const index = _.findIndex(from, (item) => item.id === id);
        from.splice(index, 1);
    }

    sortChildren () {
        if (_.isFunction(this.compareFunc)) {
            this.children.sort(this.compareFunc);
        }
    }

    existChildren (id) {
        return !!_.find(this.children, (item) => item.id === id);
    }

    applyChildren (children) {
        _.each(children, (child) => {
            if (!this.existChildren(child.id)) {
                this.addNode(child);
            }
        });
    }

    findChildren (id, node = this, byKey = 'id') {
        let result = null;
        _.each(node.children, (child) => {
            if (child[byKey] === id) {
                result = child;
            } else if (child.hasChildren) {
                result = this.findChildren(id, child, byKey);
            }
            return !result;
        });
        return result;
    }

    getChild (id, from = this.children) {
        return _.find(from, (item) => item.id === id);
    }

    getNext () {
        if (this.parent) {
            const index = _.findIndex(this.parent.children, (item) => item.id === this.id);
            if (index < this.parent.children.length - 1) {
                return this.parent.children[index + 1];
            }
            return null;
        }
        return null;
    }

    getPrev () {
        if (this.parent) {
            const index = _.findIndex(this.parent.children, (item) => item.id === this.id);
            if (index > -1) {
                return this.parent.children[index - 1];
            }
            return null;
        }
        return null;
    }

    get superRoot () {
        let node = this;
        while (node?.parent) {
            node = node.parent;
        }
        return node;
    }

    tickTree () {
        this.superRoot.key = uid();
    }

    getParentBy (key, value) {
        let node = this;
        while (node[key] !== value && node?.parent) {
            node = node.parent;
        }
        return node;
    }

    save () {
        console.log('save default', this.label);
    }

    delete () {
        const sql = `DELETE FROM tree_nodes WHERE id=${this.serverId}`;
        return queryBot(sql);
    }

    saveData (saveData) {
        let descr = _.isObject(saveData) ? JSON.stringify(saveData) : String(saveData);
        descr = descr.replace(/[\n\r]/g, '');
        const mockupId = this.getParentBy('innertype', 'mockup')?.serverId || 0;
        if (this.serverId) {
            return queryBot2('update-tree-node', {
                title: this.label,
                descr,
                target: this.parent?.serverId || this.target,
                serverId: this.serverId,
            });
        }
        return queryBot2('insert-portfolio-doc', {
            title: this.label,
            type: this.type,
            descr,
            target: this.parent?.serverId || 0,
            mockupId,
        })
            .then((resp) => {
                this.serverId = resp.data.id;
            });
    }

    get dataJSON () {
        this.p_dataJSON = null;
        try {
            this.p_dataJSON = JSON.parse(this.description.replaceAll('\'', '"'));
        } catch {
            console.error('JSON.parse description error', this.type, this.description);
            this.p_dataJSON = null;
        }
        return this.p_dataJSON;
    }
}
